export const PersonalizationDrawer = (destinationLang) => {
  return [
    {
      FormKey: "personalization-drawer-navbar-title",
      Key: "تنظیمات",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "general-settings-label-speech-to-text",
      Key: "گفتار به متن",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "personalization-drawer-label-microphone",
      Key: "میکروفون",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "personalization-drawer-label-edit-language",
      Key: "ویرایش زبان",
      DistinitationLanguage: destinationLang,
    },
  ];
};
